
import type { IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IFiltroVisitaCliente } from "./entidades/IFiltroVisitaCliente";
import type { IVisitaCliente } from "./entidades/IVisitaCliente";

export class GestionArchivosModelo {
    

    constructor() { }
    public async obtenerVisitasCliente(filtro: IFiltroVisitaCliente): Promise<IRespuestaApiLista<IVisitaCliente>> {
        const { data } = await api.post(
            `/api/Reporte/GenerarReporteVisitasCliente`, filtro, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async descargarArchivoVisita(visitaId: number): Promise<IRespuestaApiObjeto<IVisitaCliente>> {
        const { data } = await api.get(
            `/api/Reporte/GenerarReportePDFPorVisita/${visitaId}`, {
            headers: {
                "Content-Type": "application/json",

            },
        });
        return data;
    }

    public async descargarZipVisitas(visitasId: number[]): Promise<void> {
        const response = await api.post(
            `/api/Reporte/GenerarReportesZip`,
            { VisitaIds: visitasId },
            { responseType: "blob" }
        );

        // 🔹 Generar nombre dinámico desde frontend
        const generarNombreArchivo = (): string => {
            const ahora = new Date();

            const pad = (num: number) => num.toString().padStart(2, "0");

            const yyyy = ahora.getFullYear();
            const MM = pad(ahora.getMonth() + 1);
            const dd = pad(ahora.getDate());
            const HH = pad(ahora.getHours());
            const mm = pad(ahora.getMinutes());
            const ss = pad(ahora.getSeconds());

            return `Reportes_${yyyy}${MM}${dd}${HH}${mm}${ss}.zip`;
        };

        const fileName = generarNombreArchivo();

        const blob = new Blob([response.data], {
            type: "application/zip",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    }


}

